import React, { Component } from "react";
import { string, func } from "prop-types";
import { connect } from "react-redux";
import { clearErrorsForInput } from "../../actions/error.js";
import "./Textbox.css";

class Textbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      msgs: [""]
    };

    this.onChange = this.onChange.bind(this);
    this.renderErrors = this.renderErrors.bind(this);
  }

  static PropTypes = {
    name: string,
    placeholder: string,
    onChange: func,
    value: string,
    ph: string
  };

  onChange(e) {
    if (this.props.onChange) {
      this.props.onChange(e.target.value, e.target.name);
      this.props.deleteErrors(e.target.name);
    }
  }

  renderErrors() {
    if (!this.state.error) {
      return null;
    } else {
      return (
        <ul className="errors">
          {this.state.msgs.map((msg, i) => (
            <li className="error-msg" key={i}>
              {msg}
            </li>
          ))}
        </ul>
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      //check if this.props.name is in Object.keys()
      if (Object.keys(nextProps.errors).includes(this.props.name)) {
        this.setState({ error: true, msgs: nextProps.errors[this.props.name] });
      } else {
        this.setState({ error: false, msgs: [] });
      }
    }
  }

  render() {
    return (
      <div className="textbox-container">
        <div className="textbox">
          <textarea
            placeholder={this.props.ph}
            name={this.props.name ? this.props.name : this.props.type}
            onChange={this.onChange}
            value={this.props.value}
            className={this.state.error ? "has-error" : ""}
            spellCheck="false"
          >
            {this.props.value}
          </textarea>
        </div>
        {this.renderErrors()}
      </div>
    );
  }
}

const mapStateToProps = state => ({ errors: state.errors });

const mapDispatchToProps = {
  deleteErrors: inputName => dispatch =>
    dispatch(clearErrorsForInput(inputName))
};

export default connect(mapStateToProps, mapDispatchToProps)(Textbox);



// WEBPACK FOOTER //
// ./src/common/textbox/Textbox.js